import { usePath } from '@resultadosdigitais/front-hub/react'
import { Button, ButtonGroup, FormFeedback, FormLabel, Text } from '@resultadosdigitais/tangram-components'
import MFAappChallengeCode from 'components/MFAappChallengeCode'
import MFAauthAppReminder from 'components/MFAauthAppReminder'
import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { buildFaqURL } from 'services/urlsTranslations'
import styled from 'styled-components/macro'
import useQuery from '../../hooks/useQuery'
import loginService from '../../login-service'
import Form from '../Form'
import MFAappChallengeImage from './mfa_app_smartphone.svg'

const StyledImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: stretch;
  padding-bottom: var(--size-spacing-02);
`

const StyledImage = styled.img`
  height: auto !important;
`

const MFAappChallengeSection = styled.section`
  padding-top: var(--size-spacing-05);
  display: grid;
  gap: var(--size-spacing-05);
`

const FaqContainer = styled.div`
  margin: 0px;
`

const StyledButtonGroup = styled(ButtonGroup)`
  display: flex;
  justify-content: flex-end;
  align-items: stretch;
  gap: var(--size-spacing-03);
`
const StyledText = styled(Text)`
  margin-bottom: 0;
  & a {
    text-decoration: none;
    color: var(--color-primary-70);
    font-weight: 700;
  }
`
const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const FormLabelStyled = styled(FormLabel)`
  font-weight: normal;
`

const FormFeedbackStyledError = styled(FormFeedback)`
  margin-top: 0 !important;
  color: var(--color-red-50);
`

const Header = styled.header``

const MINIMUM_NUMBER_CODE = 6

function MFAappChallengeForm({ email, enableMfaApp, recoveryByAdminLink, goToLoginForm }) {
  const { t, i18n } = useTranslation()
  const assetPath = usePath()
  const [code, setCode] = useState()
  const [hasError, setHasError] = useState(false)
  const [countError, setCountError] = useState(0)
  const [resetCode, setResetCode] = useState(false)
  const query = useQuery()
  const shouldNextButtonDisabled = !code || code.length < MINIMUM_NUMBER_CODE

  const handleGoBack = () => goToLoginForm && goToLoginForm()

  const handleTryAnotherMfa = () => {
    window.location.assign('/mfa/recover_account')
  }

  const submitForm = async () => {
    const redirectTo = query.get('redirect_to') || query.get('return_to') || ''
    try {
      const { data } = await loginService.mfaLogin({
        email,
        totpCode: code,
        enableMfaApp,
        recoveryByAdminLink,
        redirectTo,
      })
      setHasError(false)
      window.location.assign(data.redirectTo)
    } catch (e) {
      setResetCode(true)
      setHasError(true)
      setCountError(countError + 1)
      console.error(e)
    }
  }

  return (
    <Form>
      <StyledImageContainer>
        <StyledImage src={assetPath(MFAappChallengeImage)} alt={t('MfaChallenge.Acessibility.MfaChallengeAlt')} />
      </StyledImageContainer>
      <MFAappChallengeSection>
        <Header>
          <StyledText token={Text.tokens.TEXT_XL_BOLD} textColor="--color-gray-100">
            {t('MFAappChallenge.Title')}
          </StyledText>
        </Header>
        <FormContainer>
          <FormLabelStyled htmlFor="code">{t('MFAappChallenge.InputCodeLabel')}</FormLabelStyled>
          <MFAappChallengeCode
            hasError={hasError}
            onChange={value => setCode(value)}
            onSend={submitForm}
            reset={resetCode}
            resetCallback={() => setResetCode(false)}
          />
          {hasError && <FormFeedbackStyledError id="field_helper">{t('MFAappChallenge.ErrorMessage')}</FormFeedbackStyledError>}
        </FormContainer>
        <FaqContainer>
          <StyledText token={Text.tokens.TEXT_MD_REGULAR} textColor="--color-gray-100">
            <Trans
              i18nKey="MFAappChallenge.Faq"
              components={[
                <a href={buildFaqURL(i18n.language)} target="_blank" rel="noopener noreferrer">
                  .
                </a>,
              ]}
            />
          </StyledText>
        </FaqContainer>
        <MFAauthAppReminder />
      </MFAappChallengeSection>
      <StyledButtonGroup>
        <Button onClick={handleGoBack} kind={Button.kinds.tertiary}>
          {t('MFAappChallenge.BackButton')}
        </Button>
        {recoveryByAdminLink && (
          <Button onClick={handleTryAnotherMfa} kind={Button.kinds.secondary}>
            {t('MFAappChallenge.TryAnotherMFAButton')}
          </Button>
        )}
        <Button disabled={shouldNextButtonDisabled} onClick={submitForm}>
          {t('MFAappChallenge.NextButton')}
        </Button>
      </StyledButtonGroup>
    </Form>
  )
}

export default MFAappChallengeForm
